import React, { useEffect, useState, useRef } from "react";
import MultiSelect from "../../../ui/MultiSelect";
import {
  MultiValue,
  Option,
  ValueContainer,
  ValueContainerDisplayResult,
} from "Components//corporate/reports/MultiValueComponents";
import { connect } from "react-redux";
import {
  fetchHotelGroupsForAnalytics,
  fetchVenuesForGivenGroupsAndBrands,
} from "../../../services/hotelGroupService/hotelGroupFilterService";
import { isGroupAdmin, isGroupUser, isRolePlatformAdmin, token, venues } from "../../../modules/auth";
import { Field, getFormValues, reduxForm } from "redux-form";
import { Checkbox } from "../../../ui";
import CheckboxForAnalytics from "../../../ui/CheckboxForAnalytics";
import { ButtonPrimary } from "../../../Components/Button";
import Loading from "../../../Components/Loading";
import { group } from "../../../modules/cms";
import { venueHasPermission } from "../../../modules/permissions";
import { PERMISSIONS } from "../../../constants";

let HotelGroupFilters = ({
  token,
  change,
  values,
  fetch,
  isRolePlatformAdmin,
  hasPassedVenues,
  data,
  passedVenues = [],
  personalVenues = [],
  noSearch = false,
  alwaysRevealSpecificOnStart = false,
  alwaysRevealGroupsOnStart = false,
  noTimeout = true,
  isNonAnalytics = false,
  venuePermissionToCheck = null,
  resetAnalyticsData = null,
  isGroup,
}) => {
  const [hotelGroups, setHotelGroups] = useState([]);
  const [hotelBrands, setHotelBrands] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState(
    values && values.selectedVenues ? values.selectedVenues : []
  );
  const [selectedHotelGroups, setSelectedHotelGroups] = useState(
    values && values.selectedGroups ? values.selectedGroups : []
  );
  const [selectedHotelBrands, setSelectedHotelBrands] = useState(
    values && values.selectedBrands ? values.selectedBrands : []
  );
  const [whichVenues, setWhichVenues] = useState(
    values && values.which_venue ? values.which_venue : []
  );
  const [hideWitchVenue, setHideWhichVenue] = useState(true);
  const [venues, setVenues] = useState([]);
  const [groups, setGroups] = useState(false);
  const [reset, setReset] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [hideGroups, setHideGroups] = useState(!alwaysRevealGroupsOnStart);
  const [showSpecificVenues, setShowSpecificVenues] = useState(
    alwaysRevealSpecificOnStart
  );
  const [loading, setLoading] = useState(false);
  const [hasHitBreakpoint, setHasHitBreakpoint] = useState(false);
  const breakpoint = 500;

  let deselectAll = () => {
    setSelectedVenues([]);
    change("specific_venues", []);
    change("venue_id", "");
    change("venues", []);
    if (!hideWitchVenue) {
      handleVenueAutoSelect(
        getVenueOptions().find(option => option.value === "specific")
      );
    }
    setHideWhichVenue(true);
  };
  let changeVenuesToFormVenues = () => {
    if (values) {
     // change("venue_id", values.venue_id);
    //  change("venues", values.venues);
      let noGroups = selectedHotelGroups.find((group) => {
        return group.value === '*'
      });
      if(!noGroups && (selectedHotelGroups &&  selectedHotelGroups.length > 0)) {
        //leaving this here for now.
      }else{
        //change("specific_venues", []);
        //change("selectedVenues", []);
        //setSelectedVenues([]);
      }
      if (!hideWitchVenue) {
        handleVenueAutoSelect(
          getVenueOptions().find(option => option.value === "specific")
        );
      }
    }
  };

  let changeVenuesToPassedVenues = () => {
    // change("venue_id", passedVenues.map(venue => venue.id).join());
    // change(
    //   "venues",
    //   passedVenues.map(venue => venue.id)
    // );
    if(isNonAnalytics) {
      change(
        "specific_venues",
        passedVenues.map(v => v.id)
      );
    }

    setVenues(passedVenues);
    //setSelectedVenues(passedVenues);
  };

  let changeVenuesToPersonalVenues = () => {
    // change("venue_id", personalVenues.map(venue => venue.id).join());
    change(
      "venues",
      personalVenues.map(venue => venue.id)
    );
    if(isNonAnalytics) {
      change(
        "specific_venues",
        passedVenues.map(v => v.id)
      );
    }
    setVenues(personalVenues);
  };
  useEffect(() => {
    if (!values || !values.venue_id) {
      changeVenuesToPassedVenues();
    } else {
      changeVenuesToFormVenues();
    }

    setLoading(true);
    let response = localStorage.getItem('hotelGroupsForAnalyticsResponse') && localStorage.getItem('hotelGroupsForAnalyticsResponse') !== 'undefined' ? JSON.parse(localStorage.getItem('hotelGroupsForAnalyticsResponse')) : null
    if(!response) {
      fetchHotelGroupsForAnalytics(token).then(response => {
        if(response) {
          localStorage.setItem('hotelGroupsForAnalyticsResponse',  JSON.stringify(response));
          handleHotelGroupsForAnalytics(response);
        }
      });
    }else{
      handleHotelGroupsForAnalytics(response)
    }
    if(isNonAnalytics) {
      localStorage.removeItem('hotelGroupsForAnalyticsResponse')
      localStorage.removeItem('venuesForHotelGroups')
      localStorage.removeItem('selectedGroups')
    }
    return () => {
    };


  }, []);

  let handleHotelGroupsForAnalytics = (response) => {
    if (response && typeof response.data !== "undefined") {
      if (response.data.length === 0) {
        change(
          "which_venues",
          getVenueOptions().filter(option => option.value === "specific")
        );
        setWhichVenues(
          getVenueOptions().filter(option => option.value === "specific")
        );
        setVenues(passedVenues);
      }

      setHideGroups(false);
      setGroups(response.data);
      setHotelGroups(
        response.data.filter(group => group.parentGroup === null)
      );
      setHotelBrands(
        response.data.filter(group => group.parentGroup !== null)
      );
      if (isRolePlatformAdmin) {
        setHideGroups(true);
      }
      if (!noTimeout) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        setLoading(false);
      }
    }
  }

  useEffect(() => {

    handleVenueAutoSelect(
      getVenueOptions().find(option => option.value === "specific")
    );
    setHideWhichVenue(true);
    setShowSpecificVenues(true);
  }, [hasHitBreakpoint]);

  useEffect(() => {
    if (!selectedHotelGroups || (setSelectedHotelGroups && selectedHotelGroups.length === 0)) {
      if ((hotelGroups && hotelGroups.length === 1) &&  (passedVenues && passedVenues.length === 0)) {
        handleHotelGroupSelect(
          getHotelGroupOptions().find(
            group => group.value === hotelGroups[0].id
          ),
          true
        );
      } else if (
        (hotelGroups && hotelGroups.length > 1) ||
        ((hotelGroups && hotelGroups.length === 1) && (passedVenues && passedVenues.length !== 0))
      ) {
        handleHotelGroupSelect(
          getHotelGroupOptions().find(group => group.value === "*"),
          true
        );
      }
    } else {
      if (getHotelGroupOptions() && getHotelGroupOptions().length > 0) {
        handleHotelGroupSelect(
          getHotelGroupOptions().find(
            group => group.value === selectedHotelGroups[0].value
          ),
          true
        );
        let autoSelect = null;
        if (
          selectedHotelGroups && selectedHotelGroups.filter(group => group.value === "*").length === 0
        ) {

        }
      }
    }
  }, [hotelGroups]);

  useEffect(() => {
    let groupIds = [];
    if (selectedHotelBrands && selectedHotelBrands.length > 0) {
      selectedHotelBrands.forEach(group => {
        groupIds.push(group.value);
      });
      if(localStorage.getItem('venuesForHotelGroups') && typeof localStorage.getItem('venuesForHotelGroups') !== 'undefined') {
        if(localStorage.getItem('venuesForHotelGroups') !== 'undefined') {
          setVenues(JSON.parse(localStorage.getItem('venuesForHotelGroups')))
        }
      }else{
        setLoading(true)
        fetchVenuesForGivenGroupsAndBrands(groupIds, venuePermissionToCheck, token, true, isNonAnalytics).then(
          response => {
            localStorage.setItem('venuesForHotelGroups', JSON.stringify(response));
            setVenues(response);
            setLoading(false)
          }
        );
      }

    } else {
      if (selectedHotelGroups && selectedHotelGroups.length > 0) {
        if (
          selectedHotelGroups.filter(group => group.value === "*").length === 0
        ) {
          selectedHotelGroups.forEach(group => {
            groupIds.push(group.value);
          });
          if(localStorage.getItem('venuesForHotelGroups') && typeof localStorage.getItem('venuesForHotelGroups') !== 'undefined') {
            if(localStorage.getItem('venuesForHotelGroups') !== 'undefined') {
              setVenues(JSON.parse(localStorage.getItem('venuesForHotelGroups')))
            }
          }else{
            setLoading(true)
            fetchVenuesForGivenGroupsAndBrands(groupIds, venuePermissionToCheck, token, true, isNonAnalytics).then(
              response => {
                localStorage.setItem('venuesForHotelGroups', JSON.stringify(response));
                setVenues(response);
                setLoading(false)
              }
            );
          }

        } else {
          if (groups && groups.length > 0) {
            //resetGroupDropdowns();
          }
        }
      }
    }
  }, [selectedHotelGroups, selectedHotelBrands]);

  const getHotelGroupOptions = () => {
    let options = [];
    if (hotelGroups &&  Object.keys(hotelGroups) && Object.keys(hotelGroups).length > 0) {
      let groups = [];
      Object.values(hotelGroups).forEach(group => {
        groups = groups.concat(group);
      });
      options.push({
        text: "View All",
        value: "*",
        label: "View All",
        parent: null,
        childVenues: null,
      });
      groups
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
            parent: group.parentGroup,
            childVenues: group.childVenues,
          });
        });
    }
    return options;
  };

  const getHotelBrandOptions = () => {
    let options = [];
    if (hotelBrands && Object.keys(hotelGroups) && Object.keys(hotelBrands).length > 0) {
      let brands = [];
      Object.values(hotelBrands).forEach(brand => {
        brands = brands.concat(brand);
      });
      brands
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(brand => {
          options.push({
            text: brand.name,
            value: brand.id,
            label: brand.name,
            parent: brand.parentGroup,
            venues: brand.venues,
          });
        });
    }
    return options;
  };
  const getVenueOptions = () => {
    let options = [
      { text: "All Venues", value: "all", label: "All Venues" },
      {
        text: "Select Specific Venues",
        value: "specific",
        label: "Select Specific Venues",
      },
    ];

    return options;
  };

  const handleHotelBrandSelect = e => {
    let params = [];
    if (e) {
      e.map(brand => {
        params.push(brand);
      });
    } else {
      if (
        (selectedHotelGroups && selectedHotelGroups.filter(group => group.value === "*").length === 0)
      ) {

        let uniqueVenues = [
          ...new Set(getVenueIdsFromGroup(selectedHotelGroups).flat(2)),
        ];
        change("venue_id", uniqueVenues.join());
        change("venues", uniqueVenues);
        change("specific_venues", []);
        if(uniqueVenues && uniqueVenues.length) {
          setHasHitBreakpoint(false);
        }else{
          setHasHitBreakpoint(false)
        }
        setSelectedVenues([]);
      } else {
        localStorage.removeItem('venuesForHotelGroups')

        setSelectedHotelBrands([]);
        setSelectedVenues([]);
        setShowSpecificVenues(true);
        changeVenuesToPersonalVenues();
        setVenues(personalVenues);
        return;
      }
      localStorage.removeItem('venuesForHotelGroups')
      setSelectedHotelBrands([]);
      change("selectedBrands", []);
      return;
    }
    let uniqueVenues = [...new Set(getVenueIdsFromGroup(params).flat(2))].filter(v => {
      if (isNonAnalytics) {
        return venueHasPermission(v, venuePermissionToCheck);
      } else {
        if(isGroup) {
          return v
        }
        return venueHasPermission(
          v,
          PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
        );
      }
    });
    change("venue_id", uniqueVenues.join());
    change("venues", uniqueVenues);
    change("selectedBrands", params);
    change("specific_venues", []);
    localStorage.removeItem('venuesForHotelGroups')
    setSelectedHotelBrands(params);
    setWhichVenues(getVenueOptions().filter(option => option.value === "all"));
    change(
      "which_venue",
      getVenueOptions().filter(option => option.value === "all")
    );
  };

  const handleHotelGroupSelect = (e, keep, reset) => {
    let params = [];
    if (e && e.value !== "*") {
      params.push(e);
    } else {
      if (e && e.value === "*") {
        params.push(e);
      }
      setSelectedHotelBrands([]);
      setSelectedVenues([]);
      setShowSpecificVenues(true);
      setHideWhichVenue(true);
      change("selectedGroups", params);
      setSelectedHotelGroups(params);
      if (reset) {
        changeVenuesToPersonalVenues();
        setVenues(personalVenues);
      } else {
        changeVenuesToPassedVenues();
        setVenues(passedVenues);
      }
      localStorage.removeItem('venuesForHotelGroups')
      setHotelBrands(groups.filter(group => group.parentGroup !== null));
      return;
    }
    if (e && e.length === 0) {
      setHotelBrands(groups.filter(group => group.parentGroup !== null));
    } else {
      setSelectedHotelGroups(params);
      setHotelBrands(
        groups.filter(
          brand =>
            brand.parentGroup &&
            params.map(param => param.value).includes(brand.parentGroup.id)
        )
      );
    }
    let childVenues = params.map(param => param.childVenues);

    let uniqueVenues = [
      ...new Set(
        getVenueIdsFromGroup(params)
          .flat(2)
          .concat(childVenues.flat(2))
      ),
    ].filter(v => {
      if (isNonAnalytics) {
        return venueHasPermission(v, venuePermissionToCheck);
      } else {

        if(isGroup) {
          return true        }
        return venueHasPermission(
          v,
          PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
        );
      }
    });

    if((uniqueVenues && uniqueVenues.length > 0)) {
      if(typeof uniqueVenues[0] === 'object') {
        let ids = uniqueVenues.filter((venue) => {
          return values.specific_venues.includes(venue.id)
        }).map((venue) => {
          return venue.id
        })
        if(!keep) {
          change("venue_id", ids.join());
          change("venues", ids);
        }
      }else {
        if(!keep) {
          change("venue_id", uniqueVenues.join());
          change("venues", uniqueVenues);
          change("specific_venues", uniqueVenues);
        }

      }
    }

    change("selectedGroups", params);
    localStorage.setItem('selectedGroups', params.map((group) => group.id).join());
    if (!keep) {
      change("specific_venues", []);
      setWhichVenues(
        getVenueOptions().filter(option => option.value === "all")
      );
      setSelectedHotelBrands([]);
    }
  };

  const getVenueIdsFromGroup = params => {
    return params.map(param => {

      return groups
        .filter(group => group.id === param.value)
        .map(group => {
          return group.venues.filter(v => {
            if (isNonAnalytics) {
              return venueHasPermission(v, venuePermissionToCheck);
            } else {
              if(isGroup) {
                return v
              }
              return venueHasPermission(
                v,
                PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
              );
            }
          }).map(venue => {
            return venue.id;
          });
        });
    });
  };

  const handleVenueAutoSelect = e => {
    if (e.value === "all") {
      setWhichVenues(e);
      change("which_venue", e);

      if (selectedHotelBrands && selectedHotelBrands.length > 0) {
        let uniqueVenues = [
          ...new Set(getVenueIdsFromGroup(selectedHotelBrands).flat(2)),
        ];
        change("venue_id", uniqueVenues.join());
        change("venues", uniqueVenues);
      } else if (selectedHotelGroups && selectedHotelGroups.length > 0) {

        let childVenues = selectedHotelGroups.map(param => param.childVenues);
        let uniqueVenues = [
          ...new Set(
            getVenueIdsFromGroup(selectedHotelGroups)
              .flat(2)
              .concat(childVenues.flat(2))
          ),
        ];
        change("venue_id", uniqueVenues.join());
        change("venues", uniqueVenues);
      }
    } else {
      if (
        (!selectedHotelBrands ||( selectedHotelBrands  && selectedHotelBrands.length === 0)) &&
        (!selectedHotelGroups || (selectedHotelGroups && selectedHotelGroups.length === 0))
      ) {
        change("which_venues", e.value);
        setShowSpecificVenues(true);

        changeVenuesToPersonalVenues();
        setWhichVenues(e);
        setVenues(passedVenues);
        change("which_venue", e);
      } else {
        change("which_venues", e.value);
        setShowSpecificVenues(true);
        changeVenuesToFormVenues();
        setWhichVenues(e);
        change("which_venue", e);
      }
    }
  };

  const handleVenueSelect = e => {
    let params = [];
    if (!e || e.length === 0) {
      deselectAll();
      if(!isNonAnalytics && resetAnalyticsData) {
        resetAnalyticsData();
      }
      return;
    }
    params = venues.filter(venue => e.includes(venue.id));
    setSelectedVenues(params);
    change("selectedVenues", params);
    change("venue_id", e.join());
    change("venues", e);
  };
  if (loading) {
    return <Loading />;
  }
  let filteredVenues = venues;
  if(!isRolePlatformAdmin) {
    filteredVenues = venues ? venues
      .filter(v => {
        if (isNonAnalytics) {
          return venueHasPermission(v, venuePermissionToCheck);
        } else {
          if(isGroup) {
            return v
          }
          return venueHasPermission(
            v,
            PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
          );
        }
      }) : [];
  }

  return (
    <div>
      {hideGroups ? (
        <></>
      ) : (
        <div className={"flex my-3"}>
          <div className={"mr-5"}>
            {!data && getHotelGroupOptions().length > 0 ? (
              <MultiSelect
                name="hotel_group"
                label="Filter by Hotel Group"
                options={getHotelGroupOptions()}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                wrapperClassName="mb-0"
                onChange={e => handleHotelGroupSelect(e)}
                value={selectedHotelGroups}
                autoComplete={"off"}
                components={{
                  ValueContainer: ValueContainerDisplayResult,
                }}
                style={{
                  searchBox: {
                    "border-radius": "0px",
                  },
                }}
              />
            ) : null}
          </div>
          {!data &&
          (selectedHotelGroups && selectedHotelGroups.filter(group => group.value === "*").length ===
            0) &&
            (getHotelBrandOptions() && getHotelBrandOptions().length > 0) ? (
            <div className={"mr-5"}>
              <MultiSelect
                name="hotel_brand"
                label="Filter by Specific Hotel Brand"
                isMulti
                options={getHotelBrandOptions()}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                wrapperClassName="mb-0"
                onChange={e => handleHotelBrandSelect(e, true)}
                autoComplete={"off"}
                value={selectedHotelBrands}
                style={{
                  searchBox: {
                    "border-radius": "0px",
                  },
                }}
              />
            </div>
          ) : (
            <></>
          )}
          {hideWitchVenue ? (
            <></>
          ) : (
            <div className={"mr-5"}>
              <MultiSelect
                name="which_venues"
                label="Which Venues?"
                options={getVenueOptions()}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                wrapperClassName="mb-0"
                onChange={e => {
                  handleVenueAutoSelect(e);
                }}
                autoComplete={"off"}
                value={whichVenues}
                components={{
                  ValueContainer: ValueContainerDisplayResult,
                }}
                style={{
                  searchBox: {
                    "border-radius": "0px",
                    width: "100%",
                  },
                }}
              />
            </div>
          )}
        </div>
      )}
      {showSpecificVenues && (
        <div
          className={"p-4 mx-0 mt-2 mb-2 border-2 border-grey "}
          style={{
            maxHeight: showAll ? "auto" : "200px",
            overflow: showAll ? "visible" : "auto",
          }}
        >
          <Field
            name="specific_venues"
            label="Filter by specific Venue"
            component={CheckboxForAnalytics}
            hideLicenses={isNonAnalytics}
            canViewLicenses={(isGroup || isRolePlatformAdmin)}
            onChange={(e, values) => {
              handleVenueSelect(e);
            }}
            withSelectAll={true}
            options={filteredVenues
              .map(v => ({
                text: v.name,
                value: v.id,
              }))}
            isShowingAll={showAll}
            selectAll={() => {
              setSelectedVenues(filteredVenues);
              change(
                "specific_venues",
                filteredVenues.map(v => v.id)
              );
              change("venue_id", filteredVenues.map(v => v.id).join());
              change(
                "venues",
                filteredVenues.map(v => v.id)
              );
            }}
            deselectAll={() => {
              deselectAll();
            }}
            selectUnlicensed={() => {

              let venues  = filteredVenues.filter(v => {
                return !venueHasPermission(
                  v,
                  PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
                );
              });
              setSelectedVenues(venues);
              change(
                "specific_venues",
                venues.map(v => v.id)
              );
              change("venue_id", venues.map(v => v.id).join());
              change(
                "venues",
                venues.map(v => v.id)
              );

            }}
            selectLicensed={() => {
              let venues  = filteredVenues.filter(v => {
                return venueHasPermission(
                  v,
                  PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
                );
              });
              setSelectedVenues(venues);
              change(
                "specific_venues",
                venues.map(v => v.id)
              );
              change("venue_id", venues.map(v => v.id).join());
              change(
                "venues",
                venues.map(v => v.id)
              );
            }}
            reset={() => {
              handleHotelGroupSelect(
                getHotelGroupOptions().find(group => group.value === "*"),
                false,
                true
              );
            }}
          />
        </div>
      )}
      {noSearch === true ||
      (showSpecificVenues && (values && values.specific_venues && values.specific_venues.length === 0)) ? (
        <></>
      ) : (
        <div className={"pb-2"}>
          <ButtonPrimary
            onClick={() => {
              fetch();
            }}
          >
            Update Results
          </ButtonPrimary>
        </div>
      )}
    </div>
  );
};
export default connect((state, ownProps) => {
  let passedVenues =
    typeof ownProps.personalVenues !== "undefined" &&
    ownProps.personalVenues.length > 0
      ? ownProps.personalVenues
      : venues(state).filter(v => {
        if (ownProps.isNonAnalytics) {
          return venueHasPermission(v, (ownProps.venuePermissionToCheck));
        } else {
          if(isGroupUser(state) || isGroupAdmin(state))
          {
            return v
          }
          return venueHasPermission(
            v,
            PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
          );
        }
      });
  return {
    token: token(state),
    hasPassedVenues: typeof ownProps.personalVenues !== "undefined",
    passedVenues: passedVenues,
    personalVenues: isRolePlatformAdmin(state) ? ownProps.personalVenues : venues(state).filter(v => {
      if (ownProps.isNonAnalytics) {
        return venueHasPermission(v, (ownProps.venuePermissionToCheck));
      } else {
        return venueHasPermission(
          v,
          PERMISSIONS.CAN_BE_INCLUDED_IN_SITE_ANALYTICS
        );
      }
    }),
    isRolePlatformAdmin: isRolePlatformAdmin(state),

    isGroup:  isGroupUser(state) || isGroupAdmin(state)
  };
})(HotelGroupFilters);
